/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Footer_Link_Market_DataInputs */

const en_landing_footer_link_market_data = /** @type {(inputs: Landing_Footer_Link_Market_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Market data`)
};

/**
* | output |
* | --- |
* | "Market data" |
*
* @param {Landing_Footer_Link_Market_DataInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const landing_footer_link_market_data = /** @type {((inputs?: Landing_Footer_Link_Market_DataInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Footer_Link_Market_DataInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_landing_footer_link_market_data(inputs)
});